export default __webpack_public_path__ + "static/media/naked-cake.034ff43d.jpg";